var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsSnoozeEnabled24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96959 9.87502C8.96959 9.46081 9.30538 9.12502 9.71959 9.12502H14.5C14.791 9.12502 15.0558 9.29337 15.1792 9.55691C15.3026 9.82044 15.2625 10.1316 15.0762 10.3552L11.1013 15.125H14.1677C14.5819 15.125 14.9177 15.4608 14.9177 15.875C14.9177 16.2892 14.5819 16.625 14.1677 16.625H9.50002C9.20901 16.625 8.94426 16.4567 8.82083 16.1931C8.69739 15.9296 8.73755 15.6184 8.92386 15.3949L12.8987 10.625H9.71959C9.30538 10.625 8.96959 10.2892 8.96959 9.87502Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2921 2.39934C7.55481 2.71958 7.50817 3.19216 7.18793 3.45487L3.9757 6.09003C3.65546 6.35275 3.18288 6.30611 2.92017 5.98586C2.65746 5.66562 2.7041 5.19304 3.02434 4.93033L6.23657 2.29517C6.55681 2.03246 7.02939 2.0791 7.2921 2.39934Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7079 2.39934C16.4452 2.71958 16.4919 3.19216 16.8121 3.45487L20.0243 6.09003C20.3446 6.35275 20.8172 6.30611 21.0799 5.98586C21.3426 5.66562 21.2959 5.19304 20.9757 4.93033L17.7635 2.29517C17.4432 2.03246 16.9707 2.0791 16.7079 2.39934Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.375C16.1422 20.375 19.5 17.0172 19.5 12.875C19.5 8.73289 16.1422 5.37502 12 5.37502C7.85789 5.37502 4.50002 8.73289 4.50002 12.875C4.50002 17.0172 7.85789 20.375 12 20.375ZM12 21.875C16.9706 21.875 21 17.8456 21 12.875C21 7.90446 16.9706 3.87502 12 3.87502C7.02946 3.87502 3.00002 7.90446 3.00002 12.875C3.00002 17.8456 7.02946 21.875 12 21.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsSnoozeEnabled24);
export default __webpack_public_path__ + "static/media/actions-snooze-enabled-24.dde1e717989c6fa4fc6525e7e1221781.svg";
export { ForwardRef as ReactComponent };